<template>
    <div class="body">
        <div class="detay">
            <div class="sayfabaslik">
                <div class="text">
                    <div class="el-button-group">

                        <router-link v-if="$store.getters.Paket==1 && this.$store.getters.Admin>0" tag="el-button" class="el-button--small" active-class="el-button--primary"
                                     to="/yonetim/sirket" type="default"> {{$t('mYonetim.1')}}
                        </router-link>

                        <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                                     to="/yonetim/site" type="default">{{$t('mYonetim.2')}}
                        </router-link>
                        <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                                     to="/yonetim/bina" type="default">{{$t('mYonetim.3')}}
                        </router-link>
                        <router-link tag="el-button" class="el-button--small"
                                     active-class="el-button--primary" to="/yonetim/mesken" type="default">
                            {{$t('mYonetim.4')}}
                        </router-link>
                        <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                                     to="/yonetim/kisi" type="default">{{$t('mYonetim.5')}}
                        </router-link>


                    </div>
                </div>
                <div class="el-button-group btn-group float-right" v-if="this.$store.state.Sayfa.MenuDisplay">
                    <router-link tag="el-button" class="el-button--small el-button--info"
                                 v-for="Menu in this.$store.state.Sayfa.Menu" :to="Menu.Link">{{Menu.Adi}}
                    </router-link>
                </div>
            </div>

            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                SeciliBina: null,
                BinaBilgi: []
            }
        },
        created() {
            //console.log(this.$store.getters.Yetki);
            if(this.$store.getters.Yetki.yonetim=='0') this.$router.push("/403");
            if (this.$store.getters.BinaBilgi) {
                this.BinaBilgi = this.$store.getters.BinaBilgi;
                this.SeciliBina = this.BinaBilgi.id;
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/_route.vue